import React, { useRef, useEffect, useState } from 'react';
import Navbar from './Navbar';
import HeroSection from './HeroSection';
import TrustedBy from './TrustedBy';
import Globe from './Globe';
import BigBlueDifference from './BigBlueDifference';
import BigBlueAdvantage from './BigBlueAdvantage';
import AboutUs from './AboutUs';
import Services from './Services';
import PoweredBy from './PoweredBy';
import MapTestimonial from './MapTestimonial';
import BlogSection from './BlogSection';
import FAQ from './FAQ';
import ContactUs from './ContactUs';
import Footer from './Footer';
import MeetOurTeam from './MeetOurTeam';

const HomePage = () => {
  const sectionRefs = {
    hero: useRef(null),
    trustedBy: useRef(null),
    globe: useRef(null),
    // meetourteam: useRef(null),
    mapTestimonial: useRef(null),
    difference: useRef(null),
    advantage: useRef(null),
    aboutUs: useRef(null),
    services: useRef(null),
    poweredBy: useRef(null),
    blog: useRef(null),
    faq: useRef(null),
    contactUs: useRef(null),
    footer: useRef(null),
  };

  const sectionOrder = [
    { key: 'hero', color: '#02044f' },
    { key: 'trustedBy', color: '#02044f' },
    { key: 'globe', color: '#02044f' },
    // { key: 'meetourteam', color: '#02044f' },
    { key: 'mapTestimonial', color: '#86cde9' },
    { key: 'difference', color: '#86cde9' },
    { key: 'advantage', color: '#86cde9' },
    { key: 'aboutUs', color: '#86cde9' },
    { key: 'services', color: '#02044f' },
    { key: 'poweredBy', color: '#86cde9' },
    { key: 'blog', color: '#86cde9' },
    { key: 'faq', color: '#86cde9' },
    { key: 'contactUs', color: '#02044f' },
    { key: 'footer', color: '#02044f' },
  ];

  const [bgColor, setBgColor] = useState('#02044f');

  const hexToRgb = (hex) => {
    const bigint = parseInt(hex.slice(1), 16);
    return {
      r: (bigint >> 16) & 255,
      g: (bigint >> 8) & 255,
      b: bigint & 255,
    };
  };

  const interpolateColor = (c1, c2, factor) => {
    return {
      r: Math.round(c1.r + (c2.r - c1.r) * factor),
      g: Math.round(c1.g + (c2.g - c1.g) * factor),
      b: Math.round(c1.b + (c2.b - c1.b) * factor),
    };
  };

  const rgbToHex = ({ r, g, b }) => {
    return `#${[r, g, b].map((x) => x.toString(16).padStart(2, '0')).join('')}`;
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;

      for (let i = 0; i < sectionOrder.length - 1; i++) {
        const ref1 = sectionRefs[sectionOrder[i].key].current;
        const ref2 = sectionRefs[sectionOrder[i + 1].key].current;

        if (!ref1 || !ref2) continue;

        const start = ref1.offsetTop;
        const end = ref2.offsetTop;
        const color1 = hexToRgb(sectionOrder[i].color);
        const color2 = hexToRgb(sectionOrder[i + 1].color);

        if (scrollY >= start && scrollY < end) {
          const progress = (scrollY - start) / (end - start);
          const blendedColor = interpolateColor(color1, color2, progress);
          setBgColor(rgbToHex(blendedColor));
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, [sectionRefs]);

  return (
    <div className="relative">
      <div
        className="fixed inset-0 z-[-1] transition-all duration-800 ease-in-out"
        style={{ backgroundColor: bgColor }}
      />
      <Navbar currentBgColor={bgColor} />
      <div className="relative z-10">
        <div ref={sectionRefs.hero}>
          <HeroSection />
        </div>
        <div ref={sectionRefs.trustedBy}>
          <TrustedBy />
        </div>
        <div ref={sectionRefs.globe}>
          <Globe />
        </div>
        {/* <div ref={sectionRefs.meetourteam}>
          <MeetOurTeam />
        </div> */}
        <div ref={sectionRefs.mapTestimonial}>
          <MapTestimonial />
        </div>
        <div ref={sectionRefs.difference}>
          <BigBlueDifference />
        </div>
        <div ref={sectionRefs.advantage}>
          <BigBlueAdvantage />
        </div>
        <div ref={sectionRefs.aboutUs}>
          <AboutUs />
        </div>
        <div ref={sectionRefs.services}>
          <Services />
        </div>
        <div ref={sectionRefs.poweredBy}>
          <PoweredBy />
        </div>
        <div ref={sectionRefs.blog}>
          <BlogSection />
        </div>
        <div ref={sectionRefs.faq}>
          <FAQ />
        </div>
        <div ref={sectionRefs.contactUs}>
          <ContactUs />
        </div>
        <div ref={sectionRefs.footer}>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default HomePage;